module.exports = __webpack_public_path__ + "static/media/banauchu-final.902ad6b3.m4v";